import type { ReactNode } from "react";

type BadgeTone = "primary" | "accent" | "secondary" | "outline";

const toneStyles: Record<BadgeTone, string> = {
  primary: "bg-primary-100 text-primary-700 border-primary-200/70",
  accent: "bg-accent-100 text-accent-800 border-accent-200/70",
  secondary: "bg-secondary-100 text-secondary-800 border-secondary-200/70",
  outline: "bg-transparent text-foreground-600 border-background-300/80",
};

interface BadgeProps {
  children: ReactNode;
  tone?: BadgeTone;
  className?: string;
}

export default function Badge({ children, tone = "secondary", className = "" }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-[11px] font-medium tracking-wide whitespace-nowrap ${toneStyles[tone]} ${className}`}
    >
      {children}
    </span>
  );
}